"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = exports["default"] = {
  pageBackground: {
    background: "url(".concat(require('../../assets/contact_preferences_bg.jpg'), ") center top no-repeat"),
    backgroundSize: 'cover',
    zIndex: -1,
    position: 'absolute',
    top: 0,
    bottom: 0,
    left: 0,
    right: 0
  }
};
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// ./node_modules/account-ion/lib/modules/common/browser/styles/contactPreferences/contactPreferencesStyles.js
// module id = 4305
// module chunks = 9